module.exports = __webpack_public_path__ + "media/images/shared/suppliers/FEBI-c57672388d91ff8ed06c6bdce0da175f.jpg";